export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 mb-10">
              有任何问题或建议？欢迎随时与我们取得联系
            </p>

            <div className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-mail-line text-primary-600 text-xl"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-500">contact@51yingshi.com</p>
                </div>
                <div>
                  <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-chat-smile-2-line text-accent-600 text-xl"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线反馈</h3>
                  <p className="text-sm text-foreground-500">页面右下角在线客服</p>
                </div>
                <div>
                  <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-question-answer-line text-secondary-600 text-xl"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">常见问题</h3>
                  <a href="#faq" className="text-sm text-primary-500 hover:text-primary-600 no-underline cursor-pointer">
                    查看FAQ &rarr;
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}